import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 via-background-50 to-accent-50/60"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/25 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
              {heroData.tag}
            </span>

            <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight mb-3">
              {heroData.title}
            </h1>

            <p className="text-sm md:text-base text-foreground-600 font-medium mb-4">
              {heroData.slogan}
            </p>

            <p className="text-sm text-foreground-700 leading-relaxed mb-6 max-w-[600px]">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center gap-6 mb-6">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="font-heading text-xl md:text-2xl font-bold text-primary-500">
                    {stat.value}
                  </span>
                  <span className="text-xs text-foreground-500">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <button
                onClick={() => handleClick(heroData.primaryCta.href)}
                className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.text}
              </button>
              <button
                onClick={() => handleClick(heroData.secondaryCta.href)}
                className="px-6 py-2.5 border border-secondary-300 text-foreground-700 hover:border-secondary-400 hover:text-foreground-900 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer bg-background-50/50"
              >
                {heroData.secondaryCta.text}
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[280px] md:w-[380px] md:h-[380px] lg:w-[420px] lg:h-[420px]">
              <div className="absolute inset-0 bg-gradient-to-br from-primary-200/40 to-accent-200/40 rounded-2xl"></div>
              <img
                src={heroData.heroImage}
                alt="今日吃瓜一站式吃瓜入口聚合平台主视觉"
                className="relative w-full h-full object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}